import { updateEntities } from 'redux-query';
import { Dispatch, ServiceLocationInfo, ServiceLocationsState } from 'types';

/**
 * Fetches coordinates for the given service location,
 * then updates the redux store entity with those coordinates
 *
 * This is a temporary solution (borrowed from PracticeActions.ts)
 * for service location coordinates. These coordinates can be provided
 * by the booking API in a future iteration of this epic:
 * https://elationhealth.atlassian.net/browse/RM-35861
 */
export const fetchServiceLocationCoordinates =
  (serviceLocation: ServiceLocationInfo) =>
  (dispatch: Dispatch): void => {
    if (!google.maps) {
      throw new Error('Google maps javascript api was not loaded correctly');
    }

    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: serviceLocation.fullAddress }, (results): void => {
      if (results?.length) {
        dispatch(
          updateEntities({
            serviceLocations: (
              prevServiceLocations: ServiceLocationsState,
            ): ServiceLocationsState => ({
              ...prevServiceLocations,
              [serviceLocation.id]: {
                ...prevServiceLocations[serviceLocation.id],
                lat: results[0].geometry.location.lat(),
                lng: results[0].geometry.location.lng(),
              },
            }),
          }),
        );
      }
    });
  };
